import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { CommonModal } from 'src/components/shared/CommonModal'
import type { InsurancePolicy } from 'src/interfaces/insurancePolicy'
import { InsurancePolicyForm } from './InsurancePolicyForm'
import type {
  InsurancePolicyFormMode,
  InsurancePolicyFormValues,
} from './InsurancePolicyForm.interface'

const FORM_ID = 'insurance-policy-form'

interface Props {
  isOpen: boolean
  mode: InsurancePolicyFormMode
  policy: InsurancePolicy | null
  isSaving: boolean
  onSubmit(values: InsurancePolicyFormValues): void
  onClose(): void
}

const InsurancePolicyFormModalComponent = ({
  isOpen,
  mode,
  policy,
  isSaving,
  onSubmit,
  onClose,
}: Props) => {
  return (
    <CommonModal
      isOpen={isOpen}
      title={mode === 'edit' ? 'Rename insurance policy' : 'Create insurance policy'}
      // Wider than the default confirm-dialog width: this modal carries a form.
      className={tw`max-w-[480px]`}
      onClose={onClose}
      buttons={
        <Fragment>
          {/* Disabled while the request is in flight so the control matches the page's
              dismissal guard — a Cancel that looks clickable but does nothing is worse. */}
          <Button size="small" color="grey" disabled={isSaving} onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            color="primary"
            type="submit"
            form={FORM_ID}
            loading={isSaving}
            disabled={isSaving}
            data-testid="insurance-policy-form-submit-button"
          >
            {mode === 'edit' ? 'Save changes' : 'Create policy'}
          </Button>
        </Fragment>
      }
    >
      <InsurancePolicyForm formId={FORM_ID} policy={policy} onSubmit={onSubmit} />
    </CommonModal>
  )
}

export const InsurancePolicyFormModal = memo(InsurancePolicyFormModalComponent)
